module.exports = __webpack_public_path__ + "img/VI.37abe499.png";